<template>
  <div class="worktime-tag" :title="start && end ? `${start} - ${end}` : ''">
    <template v-if="calculated.normal && calculated.overtime">
      <span class="hour">{{calculated.normal}}+{{ calculated.overtime }}</span>
      <img src="@/assets/img/tag_mix.svg" alt />
    </template>
    <template v-else-if="calculated.normal">
      <span class="hour">{{calculated.normal}}</span>
      <img src="@/assets/img/tag_nrv.svg" alt />
    </template>
    <template v-else-if="calculated.overtime">
      <span class="hour">{{calculated.overtime}}</span>
      <img src="@/assets/img/tag_irv1.svg" alt />
    </template>
    <template v-else-if="calculated.holiday">
      <span class="hour">{{calculated.holiday}}</span>
      <img src="@/assets/img/tag_irv2.svg" alt />
    </template>
    <template v-else>
      <span class="hour"></span>
      <img v-if="planned" src="@/assets/img/tag_extra.svg" alt />
      <img v-else src="@/assets/img/tag_missing.svg" alt />
    </template>
  </div>
</template>

<script>
import hours from '../mixins/hours.js';
export default {
  props: [
    'date',
    'start',
    'end',
    'planned',
    'plannedStart',
    'plannedEnd',
    'total'
  ],
  mixins: [hours],
  watch: {
    date: 'recalculate',
    start: 'recalculate',
    end: 'recalculate'
  },
  data() {
    return {
      calculated: {}
    };
  },
  methods: {
    recalculate() {
      this.calculated = this.calculateHours(this.date, this.start, this.end);
    }
  },
  mounted() {
    if (this.total) {
      this.calculated = this.total;
    } else {
      this.recalculate();
    }
  }
};
</script>

<style scoped>
.worktime-tag {
  align-items: center;
  display: inline-flex;
}
.hour {
  display: inline-flex;
  justify-content: center;
  /* margin: 0 15px; */
  width: 50px;
}
.worktime-tag > img {
  height: 20px;
  width: 34px;
}
</style>